module.exports = __webpack_public_path__ + "static/media/title.614acce3.png";